import { useEffect, useState } from 'react';
import { api, formatDateTime, getToken } from '../api';
import { Card, Dialog } from './ui';

interface Foto {
  id: string;
  aufgenommen_am: string | null;
  hochgeladen_am: string;
  erstellt_von: string;
}

/**
 * Fotos eines Einsatzes. Ein einfaches <img src> ginge nicht - die Bilder gibt
 * der Server nur mit Anmeldung heraus. Deshalb mit Token holen und als
 * Blob-Adresse anzeigen.
 */
export function EinsatzFotos({ einsatzId }: { einsatzId: string }) {
  const [fotos, setFotos] = useState<Foto[]>([]);
  const [bilder, setBilder] = useState<Record<string, string>>({});
  const [gross, setGross] = useState<string | null>(null);

  useEffect(() => {
    let aktiv = true;
    const adressen: string[] = [];
    void api<Foto[]>(`/api/einsaetze/${einsatzId}/fotos`).then(async (liste) => {
      if (!aktiv) return;
      setFotos(liste);
      for (const f of liste) {
        const res = await fetch(`/api/fotos/${f.id}`, { headers: { Authorization: `Bearer ${getToken()}` } });
        if (!res.ok || !aktiv) continue;
        const url = URL.createObjectURL(await res.blob());
        adressen.push(url);
        setBilder((alt) => ({ ...alt, [f.id]: url }));
      }
    });
    return () => {
      aktiv = false;
      adressen.forEach((u) => URL.revokeObjectURL(u));
    };
  }, [einsatzId]);

  if (fotos.length === 0) return null;
  return (
    <Card title={`Fotos (${fotos.length})`}>
      <div className="row">
        {fotos.map((f) => (
          <button key={f.id} className="link" onClick={() => setGross(f.id)} title={`${f.erstellt_von}, ${formatDateTime(f.aufgenommen_am ?? f.hochgeladen_am)}`}>
            {bilder[f.id] ? (
              <img src={bilder[f.id]} alt="" style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 8, border: '1px solid var(--line)' }} />
            ) : (
              <div style={{ width: 120, height: 120, borderRadius: 8, background: 'var(--line-soft)' }} />
            )}
          </button>
        ))}
      </div>
      {gross && bilder[gross] && (
        <Dialog titel="Foto" breit onClose={() => setGross(null)}>
          <img src={bilder[gross]} alt="" style={{ width: '100%', borderRadius: 8 }} />
        </Dialog>
      )}
    </Card>
  );
}
